const initBtnsHover = () => {
  const btns = document.querySelectorAll('.btn');

  btns.forEach((btn) => {
    const btnTextWrapper = btn.querySelector('.btn__text');
    const btnText = btnTextWrapper.textContent.trim().split('');
    btnTextWrapper.textContent = '';

    btnText.forEach((char, index) => {
      btnTextWrapper.insertAdjacentHTML(
        'beforeend',
        `<span class="btn__char" data-char="${
          char == ' ' ? '&nbsp' : char
        }" style="--char-index: ${index};">
            ${char == ' ' ? '&nbsp' : char}
        </span>`
      );
    });
  });
};

export { initBtnsHover };
